export const getDefaultValues = (channelDetails, SocialManagerChannelSocialManagerAccountID) => ({
  SocialManagerChannelSocialManagerAccountID,
  SocialManagerChannelKey: channelDetails?.SocialManagerChannelKey || '',
  SocialManagerChannelName: channelDetails?.SocialManagerChannelName || '',
});
